var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgW3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 230,
    viewBox: "0 0 230 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.072 46.0072V173.374C176.072 175.058 175.403 176.673 174.212 177.864C173.021 179.055 171.406 179.724 169.722 179.724H143.798L91.7112 165.436L39.6088 179.724H13.6528C11.9687 179.724 10.3535 179.055 9.16263 177.864C7.97175 176.673 7.30273 175.058 7.30273 173.374V46.0072L91.7112 2.23926L176.072 46.0072Z",
    fill: "url(#paint0_linear_47_2496)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.967 70.2166H71.4539C71.1131 70.244 70.7703 70.2004 70.4471 70.0888C70.124 69.9771 69.8274 69.7998 69.5762 69.5679C69.3249 69.336 69.1244 69.0546 68.9872 68.7414C68.8501 68.4282 68.7793 68.0899 68.7793 67.748C68.7793 67.4061 68.8501 67.0679 68.9872 66.7547C69.1244 66.4415 69.3249 66.16 69.5762 65.9281C69.8274 65.6962 70.124 65.5189 70.4471 65.4072C70.7703 65.2956 71.1131 65.2521 71.4539 65.2794H111.967C112.588 65.3292 113.167 65.6109 113.589 66.0683C114.011 66.5258 114.246 67.1255 114.246 67.748C114.246 68.3705 114.011 68.9702 113.589 69.4277C113.167 69.8851 112.588 70.1668 111.967 70.2166Z",
    fill: "url(#paint1_linear_47_2496)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.967 61.8665H71.4539C71.1131 61.8939 70.7703 61.8503 70.4471 61.7387C70.124 61.6271 69.8274 61.4497 69.5762 61.2178C69.3249 60.9859 69.1244 60.7045 68.9872 60.3913C68.8501 60.078 68.7793 59.7398 68.7793 59.3979C68.7793 59.056 68.8501 58.7178 68.9872 58.4046C69.1244 58.0914 69.3249 57.8099 69.5762 57.578C69.8274 57.3461 70.124 57.1688 70.4471 57.0571C70.7703 56.9455 71.1131 56.902 71.4539 56.9293H111.967C112.588 56.9791 113.167 57.2608 113.589 57.7183C114.011 58.1757 114.246 58.7754 114.246 59.3979C114.246 60.0204 114.011 60.6201 113.589 61.0776C113.167 61.535 112.588 61.8167 111.967 61.8665Z",
    fill: "url(#paint2_linear_47_2496)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.967 53.532H71.4539C71.1131 53.5594 70.7703 53.5159 70.4471 53.4042C70.124 53.2926 69.8274 53.1152 69.5762 52.8833C69.3249 52.6514 69.1244 52.37 68.9872 52.0568C68.8501 51.7436 68.7793 51.4054 68.7793 51.0634C68.7793 50.7215 68.8501 50.3833 68.9872 50.0701C69.1244 49.7569 69.3249 49.4755 69.5762 49.2436C69.8274 49.0117 70.124 48.8343 70.4471 48.7227C70.7703 48.611 71.1131 48.5675 71.4539 48.5949H111.967C112.588 48.6447 113.167 48.9263 113.589 49.3838C114.011 49.8412 114.246 50.4409 114.246 51.0634C114.246 51.686 114.011 52.2856 113.589 52.7431C113.167 53.2006 112.588 53.4822 111.967 53.532Z",
    fill: "url(#paint3_linear_47_2496)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.967 45.1815H71.4539C71.1131 45.2088 70.7703 45.1653 70.4471 45.0536C70.124 44.942 69.8274 44.7646 69.5762 44.5327C69.3249 44.3008 69.1244 44.0194 68.9872 43.7062C68.8501 43.393 68.7793 43.0548 68.7793 42.7129C68.7793 42.3709 68.8501 42.0327 68.9872 41.7195C69.1244 41.4063 69.3249 41.1249 69.5762 40.893C69.8274 40.6611 70.124 40.4837 70.4471 40.3721C70.7703 40.2604 71.1131 40.2169 71.4539 40.2443H111.967C112.588 40.2941 113.167 40.5757 113.589 41.0332C114.011 41.4907 114.246 42.0903 114.246 42.7129C114.246 43.3354 114.011 43.9351 113.589 44.3925C113.167 44.85 112.588 45.1317 111.967 45.1815Z",
    fill: "url(#paint4_linear_47_2496)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 46.0072V108.286H176.072V46.0072L91.7107 2.23926L7.33398 46.0072Z",
    fill: "url(#paint5_linear_47_2496)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.072 46.0072V108.286H7.33398V46.0072L91.7107 2.23926L176.072 46.0072Z",
    fill: "url(#paint6_linear_47_2496)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M176.072 46.0072V173.374C176.072 175.058 175.403 176.673 174.212 177.864C173.021 179.055 171.406 179.724 169.722 179.724H143.797L91.7109 165.436V2.23926L176.072 46.0072Z",
    fill: "url(#paint7_linear_47_2496)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M176.072 129.241V173.374C176.072 175.058 175.403 176.673 174.212 177.864C173.021 179.055 171.406 179.724 169.722 179.724H143.798L91.7112 165.436L39.6088 179.724H13.6528C11.9687 179.724 10.3535 179.055 9.16263 177.864C7.97175 176.673 7.30273 175.058 7.30273 173.374V129.241H176.072Z",
    fill: "url(#paint8_linear_47_2496)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0913 0.381656L1.95222 46.134C1.37435 46.4366 0.89178 46.8936 0.558244 47.4541C0.224708 48.0147 0.0532882 48.6568 0.0630647 49.309V61.1837C0.052153 61.7918 0.199539 62.3923 0.490709 62.9263C0.781879 63.4602 1.20684 63.9094 1.72393 64.2295C2.24103 64.5497 2.8325 64.73 3.44028 64.7526C4.04805 64.7753 4.65128 64.6395 5.19077 64.3587L90.1549 20.2892C90.6445 20.0319 91.1893 19.8975 91.7424 19.8975C92.2955 19.8975 92.8403 20.0319 93.3299 20.2892L178.31 64.3587C178.848 64.6407 179.451 64.7772 180.058 64.7549C180.666 64.7326 181.257 64.5522 181.773 64.2316C182.289 63.9109 182.713 63.4611 183.002 62.9266C183.291 62.392 183.436 61.7913 183.422 61.1837V49.309C183.431 48.6568 183.26 48.0147 182.927 47.4541C182.593 46.8936 182.11 46.4366 181.533 46.134L93.314 0.381656C92.8224 0.130794 92.2784 0 91.7265 0C91.1746 0 90.6306 0.130794 90.139 0.381656H90.0913Z",
    fill: "url(#paint9_linear_47_2496)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0913 0.381656L1.95222 46.134C1.37435 46.4366 0.89178 46.8936 0.558244 47.4541C0.224708 48.0147 0.0532882 48.6568 0.0630647 49.309V61.1837C0.052153 61.7918 0.199539 62.3923 0.490709 62.9263C0.781879 63.4602 1.20684 63.9094 1.72393 64.2295C2.24103 64.5497 2.8325 64.73 3.44028 64.7526C4.04805 64.7753 4.65128 64.6395 5.19077 64.3587L90.1549 20.2892C90.6445 20.0319 91.1893 19.8975 91.7424 19.8975C92.2955 19.8975 92.8403 20.0319 93.3299 20.2892L178.31 64.3587C178.848 64.6407 179.451 64.7772 180.058 64.7549C180.666 64.7326 181.257 64.5522 181.773 64.2316C182.289 63.9109 182.713 63.4611 183.002 62.9266C183.291 62.392 183.436 61.7913 183.422 61.1837V49.309C183.431 48.6568 183.26 48.0147 182.927 47.4541C182.593 46.8936 182.11 46.4366 181.533 46.134L93.314 0.381656C92.8224 0.130794 92.2784 0 91.7265 0C91.1746 0 90.6306 0.130794 90.139 0.381656H90.0913Z",
    fill: "url(#paint10_linear_47_2496)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0924 9.22449L0.000564715 55.9611V61.1364C-0.010347 61.7445 0.137039 62.345 0.428209 62.879C0.719379 63.413 1.14434 63.8621 1.66143 64.1823C2.17853 64.5024 2.77 64.6827 3.37778 64.7053C3.98555 64.728 4.58878 64.5923 5.12827 64.3115L90.0924 20.2419C90.582 19.9846 91.1268 19.8502 91.6799 19.8502C92.233 19.8502 92.7778 19.9846 93.2674 20.2419L178.247 64.3115C178.786 64.5934 179.388 64.73 179.996 64.7077C180.603 64.6854 181.194 64.505 181.71 64.1843C182.227 63.8636 182.65 63.4138 182.939 62.8793C183.229 62.3447 183.373 61.744 183.359 61.1364V55.9611L93.315 9.22449C92.8173 8.96569 92.2647 8.83057 91.7037 8.83057C91.1428 8.83057 90.59 8.96569 90.0924 9.22449Z",
    fill: "url(#paint11_linear_47_2496)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M181.517 46.1342L139.066 24.1152V43.8957L178.294 64.2319C178.832 64.5138 179.435 64.6504 180.042 64.6281C180.65 64.6058 181.241 64.4254 181.757 64.1047C182.273 63.7841 182.697 63.3342 182.986 62.7997C183.275 62.2652 183.42 61.6644 183.406 61.0568V49.1822C183.416 48.53 183.244 47.8879 182.911 47.3273C182.577 46.7667 182.095 46.3097 181.517 46.0071V46.1342Z",
    fill: "url(#paint12_linear_47_2496)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M178.295 64.232C178.833 64.5139 179.436 64.6505 180.043 64.6282C180.651 64.6059 181.242 64.4255 181.758 64.1048C182.274 63.7842 182.698 63.3344 182.987 62.7998C183.276 62.2653 183.421 61.6645 183.407 61.057V49.1823C183.416 48.5301 183.245 47.888 182.912 47.3274C182.578 46.7668 182.095 46.3098 181.518 46.0073L159.642 34.6724H121.541L178.295 64.232Z",
    fill: "url(#paint13_linear_47_2496)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12709 64.232L61.8651 34.7993H23.7646L1.95205 46.1342C1.37418 46.4368 0.891612 46.8938 0.558076 47.4543C0.22454 48.0149 0.0531195 48.657 0.062896 49.3093V61.1839C0.078994 61.7725 0.242947 62.3475 0.539666 62.8561C0.836384 63.3646 1.25632 63.7903 1.76078 64.0939C2.26524 64.3976 2.83801 64.5693 3.4263 64.5935C4.01459 64.6176 4.59947 64.4933 5.12709 64.232Z",
    fill: "url(#paint14_linear_47_2496)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M143.798 92.3309V179.645H39.6094V92.3309C39.6094 90.5752 40.3068 88.8914 41.5483 87.6499C42.7898 86.4084 44.4736 85.711 46.2294 85.711H137.178C138.048 85.7089 138.91 85.8787 139.714 86.2106C140.518 86.5426 141.249 87.0301 141.864 87.6452C142.479 88.2604 142.967 88.991 143.299 89.7951C143.631 90.5992 143.8 91.461 143.798 92.3309Z",
    fill: "url(#paint15_linear_47_2496)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M127.018 147.926L112.889 133.797V165.023H127.018V147.926Z",
    fill: "url(#paint16_linear_47_2496)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2995 85.7109V179.676H39.6094V92.3627C39.6094 90.6069 40.3068 88.9231 41.5483 87.6817C42.7898 86.4402 44.4736 85.7427 46.2294 85.7427L94.2995 85.7109Z",
    fill: "url(#paint17_linear_47_2496)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M137.178 85.6948H46.2294C44.4722 85.699 42.7884 86.4 41.5474 87.644C40.3063 88.888 39.6094 90.5735 39.6094 92.3307V128.098H143.798V92.3307C143.798 90.5735 143.101 88.888 141.86 87.644C140.619 86.4 138.936 85.699 137.178 85.6948Z",
    fill: "url(#paint18_linear_47_2496)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M114.158 136.782V184.407C114.157 185.34 113.843 186.245 113.268 186.979C112.692 187.712 111.888 188.232 110.983 188.455L69.9453 198.139C69.313 198.282 68.6568 198.282 68.0244 198.139L27.0188 188.471C26.1122 188.251 25.3062 187.731 24.7303 186.997C24.1544 186.263 23.8422 185.356 23.8438 184.423V136.798C23.8429 136.24 23.955 135.688 24.1733 135.175C24.3916 134.662 24.7115 134.199 25.1138 133.813H112.92C113.322 134.199 113.642 134.662 113.86 135.175C114.078 135.688 114.19 136.24 114.19 136.798L114.158 136.782Z",
    fill: "url(#paint19_linear_47_2496)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M112.889 133.797H87.4883V193.932L110.952 188.408C111.857 188.184 112.662 187.665 113.237 186.931C113.812 186.197 114.126 185.292 114.127 184.36V136.734C114.128 136.177 114.016 135.625 113.797 135.112C113.579 134.599 113.259 134.135 112.857 133.75L112.889 133.797Z",
    fill: "url(#paint20_linear_47_2496)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M68.977 133.797V198.139C68.6561 198.141 68.3362 198.104 68.0244 198.028L27.0188 188.36C26.1122 188.139 25.3062 187.62 24.7303 186.886C24.1544 186.151 23.8422 185.245 23.8438 184.312V136.686C23.8429 136.129 23.955 135.577 24.1733 135.064C24.3916 134.551 24.7115 134.088 25.1138 133.702L68.977 133.797Z",
    fill: "url(#paint21_linear_47_2496)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114.159 136.781V184.407C114.158 185.339 113.845 186.245 113.269 186.978C112.694 187.712 111.89 188.232 110.984 188.455L69.931 198.139C69.6196 198.217 69.2995 198.254 68.9785 198.25V133.797H112.889C113.292 134.183 113.612 134.646 113.83 135.159C114.048 135.672 114.16 136.224 114.159 136.781Z",
    fill: "url(#paint22_linear_47_2496)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68.977 168.865V198.139C68.6561 198.142 68.3362 198.104 68.0244 198.028L27.0188 188.36C26.1122 188.139 25.3062 187.62 24.7303 186.886C24.1544 186.152 23.8422 185.245 23.8438 184.312V158.753L64.4049 168.278C65.902 168.645 67.4357 168.842 68.977 168.865Z",
    fill: "url(#paint23_linear_47_2496)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M68.977 168.865V198.139C69.3031 198.142 69.6283 198.104 69.9454 198.028L110.951 188.36C111.856 188.137 112.661 187.617 113.236 186.883C113.812 186.15 114.125 185.244 114.126 184.312V158.753L73.565 168.278C72.0503 168.631 70.5006 168.813 68.9453 168.818L68.977 168.865Z",
    fill: "url(#paint24_linear_47_2496)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M112.889 133.797L71.3912 143.576C69.8256 143.949 68.1942 143.949 66.6286 143.576L25.1309 133.797C25.6624 133.274 26.3266 132.906 27.0517 132.733L68.0733 123.065C68.6984 122.907 69.3532 122.907 69.9783 123.065L85.2979 126.669V128.526H93.1243L111 132.733C111.73 132.906 112.399 133.274 112.937 133.797H112.889Z",
    fill: "url(#paint25_linear_47_2496)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2493 126.701V128.558L43.9738 138.29L25.0664 133.829C25.598 133.306 26.2621 132.938 26.9873 132.765L68.0088 123.097C68.6393 122.938 69.2993 122.938 69.9298 123.097L85.2493 126.701Z",
    fill: "url(#paint26_linear_47_2496)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2492 126.701L40.9415 137.162C40.6937 137.22 40.4726 137.359 40.3141 137.558C40.1556 137.757 40.069 138.004 40.0684 138.258V152.101C40.0684 152.249 40.1187 152.392 40.211 152.508C40.3033 152.623 40.4321 152.704 40.5763 152.736L47.1011 154.324C47.1963 154.345 47.2951 154.345 47.3902 154.323C47.4854 154.301 47.5743 154.258 47.6506 154.197C47.7268 154.136 47.7883 154.058 47.8306 153.97C47.8729 153.883 47.8948 153.786 47.8948 153.689V140.02C47.8957 139.788 47.9745 139.564 48.1185 139.382C48.2624 139.201 48.4632 139.073 48.6886 139.02L93.1392 128.542L85.2492 126.701Z",
    fill: "url(#paint27_linear_47_2496)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M61.151 136.051L48.6889 138.988C48.5122 139.033 48.3489 139.12 48.2127 139.242L40.418 137.416C40.5618 137.273 40.7435 137.174 40.9418 137.131L53.3245 134.209L61.151 136.051Z",
    fill: "url(#paint28_linear_47_2496)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4176 137.417L48.2123 139.242C48.0121 139.439 47.898 139.707 47.8948 139.988V153.689C47.8948 153.786 47.8729 153.883 47.8306 153.971C47.7883 154.059 47.7268 154.136 47.6506 154.197C47.5743 154.258 47.4854 154.301 47.3902 154.323C47.2951 154.345 47.1963 154.345 47.1011 154.324L40.5763 152.736C40.4321 152.704 40.3033 152.623 40.211 152.508C40.1187 152.392 40.0684 152.249 40.0684 152.101V138.21C40.0777 137.91 40.2029 137.626 40.4176 137.417Z",
    fill: "url(#paint29_linear_47_2496)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0527 145.434V152.101C40.0527 152.249 40.103 152.392 40.1954 152.508C40.2877 152.623 40.4166 152.704 40.5608 152.736L47.0854 154.324C47.1807 154.345 47.2795 154.345 47.3746 154.323C47.4697 154.301 47.5587 154.258 47.6349 154.197C47.7112 154.136 47.7727 154.059 47.815 153.971C47.8572 153.883 47.8792 153.786 47.8792 153.689V145.434H40.0527Z",
    fill: "url(#paint30_linear_47_2496)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7498 182.438L46.7364 186.677C46.8751 186.711 47.0198 186.713 47.1593 186.682C47.2988 186.652 47.4295 186.589 47.5414 186.501C47.6532 186.412 47.7432 186.299 47.8046 186.17C47.8659 186.041 47.8969 185.899 47.8953 185.756V175.914C47.8969 175.7 47.8254 175.492 47.6925 175.325C47.5597 175.157 47.3736 175.04 47.165 174.993L29.1943 170.754C29.0547 170.721 28.9094 170.719 28.7692 170.75C28.6289 170.78 28.4974 170.842 28.3844 170.931C28.2715 171.019 28.18 171.132 28.1168 171.261C28.0536 171.39 28.0204 171.532 28.0195 171.675V181.549C28.025 181.758 28.0998 181.958 28.2321 182.119C28.3643 182.28 28.5465 182.393 28.7498 182.438Z",
    fill: "url(#paint31_linear_47_2496)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0196 174.438V181.518C28.0179 181.732 28.0895 181.94 28.2223 182.107C28.3551 182.274 28.5413 182.391 28.7498 182.439L46.7364 186.677C46.8751 186.711 47.0198 186.713 47.1593 186.682C47.2989 186.652 47.4296 186.59 47.5414 186.501C47.6532 186.412 47.7433 186.299 47.8046 186.17C47.8659 186.041 47.897 185.899 47.8953 185.757V179.089L28.0196 174.438Z",
    fill: "url(#paint32_linear_47_2496)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1654 174.961L38.0371 172.739V184.566L46.7367 186.614C46.8754 186.648 47.0201 186.649 47.1596 186.619C47.2992 186.588 47.4299 186.526 47.5417 186.437C47.6535 186.348 47.7436 186.235 47.8049 186.106C47.8662 185.977 47.8973 185.836 47.8956 185.693V175.914C47.8972 175.7 47.8257 175.492 47.6928 175.325C47.56 175.157 47.3739 175.04 47.1654 174.993V174.961Z",
    fill: "url(#paint33_linear_47_2496)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M145.099 168.579V216.205C145.098 217.137 144.785 218.042 144.21 218.776C143.634 219.51 142.83 220.03 141.924 220.253L100.871 229.889C100.246 230.048 99.5912 230.048 98.9661 229.889L57.9446 220.221C57.0393 219.998 56.2349 219.478 55.6595 218.744C55.084 218.011 54.7708 217.106 54.7695 216.173V168.548C54.7687 167.99 54.8808 167.438 55.0991 166.925C55.3174 166.412 55.6373 165.949 56.0396 165.563H143.845C144.25 165.948 144.572 166.411 144.793 166.924C145.014 167.437 145.129 167.989 145.131 168.548L145.099 168.579Z",
    fill: "url(#paint34_linear_47_2496)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M143.814 165.595H118.414V225.73L141.878 220.206C142.783 219.982 143.587 219.462 144.163 218.729C144.738 217.995 145.051 217.09 145.053 216.158V168.532C145.051 167.973 144.936 167.421 144.715 166.908C144.494 166.395 144.171 165.933 143.767 165.547L143.814 165.595Z",
    fill: "url(#paint35_linear_47_2496)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9186 165.595V229.985C99.5978 229.987 99.2778 229.95 98.9661 229.874L57.9446 220.206C57.0393 219.982 56.2349 219.462 55.6595 218.729C55.084 217.995 54.7708 217.09 54.7695 216.158V168.532C54.7687 167.974 54.8808 167.423 55.0991 166.91C55.3174 166.397 55.6373 165.933 56.0396 165.547L99.9186 165.595Z",
    fill: "url(#paint36_linear_47_2496)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9186 200.663V229.985C99.5978 229.987 99.2778 229.95 98.9661 229.874L57.9446 220.206C57.0393 219.982 56.2349 219.462 55.6595 218.729C55.084 217.995 54.7707 217.09 54.7695 216.157V190.551L95.3307 200.076C96.844 200.437 98.3946 200.618 99.9504 200.616L99.9186 200.663Z",
    fill: "url(#paint37_linear_47_2496)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9185 200.663V229.985C100.239 229.987 100.559 229.95 100.871 229.874L141.893 220.206C142.798 219.982 143.602 219.462 144.178 218.729C144.753 217.995 145.066 217.09 145.068 216.157V190.551L104.491 200.076C102.983 200.437 101.437 200.618 99.8867 200.616L99.9185 200.663Z",
    fill: "url(#paint38_linear_47_2496)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M143.813 165.595L102.315 175.39C100.748 175.748 99.1199 175.748 97.5525 175.39L56.0547 165.595C56.5944 165.075 57.2629 164.708 57.9915 164.532L99.013 154.864C99.6381 154.705 100.293 154.705 100.918 154.864L116.253 158.451V160.309H124.08L141.955 164.516C142.66 164.704 143.301 165.077 143.813 165.595Z",
    fill: "url(#paint39_linear_47_2496)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M116.253 158.451V160.309L74.9777 170.04L56.0703 165.579C56.6101 165.059 57.2785 164.692 58.0071 164.515L99.0286 154.847C99.6537 154.689 100.309 154.689 100.934 154.847L116.253 158.451Z",
    fill: "url(#paint40_linear_47_2496)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M116.253 158.451L71.8026 168.929C71.5578 168.989 71.3403 169.13 71.1848 169.329C71.0294 169.527 70.9451 169.772 70.9453 170.024V183.852C70.9445 183.997 70.9925 184.139 71.0818 184.254C71.171 184.369 71.2962 184.451 71.4375 184.486L77.9622 186.074C78.0585 186.098 78.1591 186.1 78.2562 186.079C78.3534 186.059 78.4445 186.016 78.5226 185.955C78.6008 185.894 78.6639 185.815 78.7071 185.726C78.7503 185.636 78.7724 185.538 78.7718 185.439V171.786C78.769 171.556 78.8445 171.332 78.9858 171.15C79.1271 170.968 79.3259 170.84 79.5497 170.786L124 160.324L116.253 158.451Z",
    fill: "url(#paint41_linear_47_2496)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0924 167.849L79.6145 170.786C79.4403 170.835 79.2817 170.928 79.1541 171.056L71.3594 169.215C71.4993 169.075 71.6751 168.976 71.8674 168.929L84.2659 166.008L92.0924 167.849Z",
    fill: "url(#paint42_linear_47_2496)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M71.359 169.214L79.1379 171.056C79.0406 171.151 78.9638 171.264 78.9119 171.39C78.8601 171.516 78.8343 171.65 78.8362 171.786V185.439C78.8368 185.538 78.8147 185.636 78.7715 185.726C78.7283 185.815 78.6652 185.893 78.5871 185.955C78.5089 186.016 78.4178 186.059 78.3207 186.079C78.2235 186.1 78.123 186.098 78.0266 186.074L71.5019 184.486C71.3607 184.451 71.2354 184.369 71.1462 184.254C71.057 184.139 71.0089 183.997 71.0098 183.851V169.96C71.0247 169.676 71.15 169.408 71.359 169.214Z",
    fill: "url(#paint43_linear_47_2496)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0098 177.232V183.852C71.0089 183.997 71.057 184.139 71.1462 184.254C71.2354 184.369 71.3607 184.451 71.5019 184.487L78.0266 186.074C78.123 186.098 78.2235 186.1 78.3207 186.08C78.4178 186.059 78.5089 186.016 78.5871 185.955C78.6652 185.894 78.7283 185.815 78.7715 185.726C78.8147 185.637 78.8368 185.538 78.8362 185.439V177.216L71.0098 177.232Z",
    fill: "url(#paint44_linear_47_2496)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6915 214.237L77.6622 218.475C77.8018 218.509 77.9471 218.51 78.0873 218.48C78.2276 218.449 78.3591 218.387 78.4721 218.299C78.585 218.21 78.6765 218.097 78.7397 217.968C78.8029 217.84 78.8361 217.698 78.837 217.554V207.664C78.8386 207.45 78.767 207.243 78.6342 207.075C78.5014 206.908 78.3152 206.791 78.1067 206.743L60.1201 202.505C59.9814 202.471 59.8367 202.469 59.6972 202.5C59.5577 202.53 59.427 202.592 59.3151 202.681C59.2033 202.77 59.1133 202.883 59.0519 203.012C58.9906 203.141 58.9596 203.283 58.9612 203.426V213.3C58.9559 213.516 59.0257 213.728 59.1589 213.899C59.292 214.07 59.4802 214.189 59.6915 214.237Z",
    fill: "url(#paint45_linear_47_2496)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M58.961 206.236V213.316C58.9593 213.53 59.0309 213.738 59.1637 213.905C59.2966 214.073 59.4827 214.19 59.6912 214.237L77.662 218.476C77.8015 218.509 77.9468 218.511 78.0871 218.48C78.2273 218.449 78.3588 218.388 78.4718 218.299C78.5848 218.211 78.6763 218.098 78.7395 217.969C78.8027 217.84 78.8359 217.698 78.8367 217.555V210.935L58.961 206.236Z",
    fill: "url(#paint46_linear_47_2496)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1536 206.76L69.0254 204.601V216.428L77.7091 218.476C77.8487 218.509 77.994 218.511 78.1343 218.48C78.2745 218.449 78.406 218.387 78.519 218.299C78.6319 218.21 78.7235 218.097 78.7866 217.969C78.8498 217.84 78.8831 217.698 78.8839 217.555V207.664C78.8855 207.451 78.814 207.243 78.6811 207.075C78.5483 206.908 78.3622 206.791 78.1536 206.744V206.76Z",
    fill: "url(#paint47_linear_47_2496)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M225.031 229.985H127.033C125.716 229.985 124.452 229.462 123.52 228.53C122.588 227.598 122.064 226.334 122.064 225.016V105.412C122.064 104.094 122.588 102.831 123.52 101.899C124.452 100.967 125.716 100.443 127.033 100.443H225.031C226.349 100.443 227.613 100.967 228.545 101.899C229.476 102.831 230 104.094 230 105.412V225.016C230 226.334 229.476 227.598 228.545 228.53C227.613 229.462 226.349 229.985 225.031 229.985Z",
    fill: "url(#paint48_linear_47_2496)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M225.031 100.443H176.58V229.985H224.968C226.286 229.985 227.549 229.462 228.481 228.53C229.413 227.598 229.937 226.334 229.937 225.016V105.412C229.937 104.105 229.422 102.851 228.504 101.921C227.586 100.991 226.338 100.46 225.031 100.443Z",
    fill: "url(#paint49_linear_47_2496)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M225.031 100.443H176.58V134.353H229.937V105.412C229.937 104.094 229.413 102.831 228.481 101.899C227.549 100.967 226.286 100.443 224.968 100.443H225.031Z",
    fill: "url(#paint50_linear_47_2496)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M225.032 229.985C226.35 229.985 227.614 229.462 228.546 228.53C229.477 227.598 230.001 226.334 230.001 225.016V119.081L219.444 108.524H205.902V229.985H225.032Z",
    fill: "url(#paint51_linear_47_2496)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M122.064 144.783V225.016C122.064 226.334 122.588 227.598 123.52 228.53C124.452 229.461 125.716 229.985 127.033 229.985H225.031C226.349 229.985 227.613 229.461 228.545 228.53C229.476 227.598 230 226.334 230 225.016V144.783H122.064Z",
    fill: "url(#paint52_linear_47_2496)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M216.982 222.143H135.082C134.134 222.143 133.226 221.766 132.556 221.096C131.886 220.427 131.51 219.518 131.51 218.571V111.064C131.51 110.115 131.886 109.205 132.555 108.533C133.224 107.86 134.133 107.48 135.082 107.476H216.982C217.933 107.476 218.846 107.854 219.519 108.527C220.192 109.2 220.57 110.112 220.57 111.064V218.571C220.565 219.52 220.186 220.428 219.513 221.097C218.841 221.767 217.931 222.143 216.982 222.143Z",
    fill: "url(#paint53_linear_47_2496)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M216.983 107.476H190.455V113.572C190.455 115.256 189.786 116.871 188.596 118.062C187.405 119.253 185.789 119.922 184.105 119.922H161.88L161.436 120.367L220.587 179.518V111.064C220.587 110.112 220.209 109.2 219.536 108.527C218.863 107.854 217.95 107.476 216.999 107.476H216.983Z",
    fill: "url(#paint54_linear_47_2496)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M216.982 107.476H194.344V222.143H216.982C217.931 222.143 218.841 221.767 219.513 221.097C220.186 220.428 220.565 219.52 220.57 218.571V111.064C220.57 110.112 220.192 109.2 219.519 108.527C218.846 107.854 217.933 107.476 216.982 107.476Z",
    fill: "url(#paint55_linear_47_2496)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M131.51 192.297V218.571C131.51 219.518 131.886 220.427 132.556 221.097C133.226 221.766 134.134 222.143 135.082 222.143H216.982C217.931 222.143 218.841 221.767 219.513 221.098C220.186 220.428 220.565 219.52 220.57 218.571V192.297H131.51Z",
    fill: "url(#paint56_linear_47_2496)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M161.625 106.936H190.454V119.97H161.625V106.936Z",
    fill: "url(#paint57_linear_47_2496)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M161.625 106.936H190.454V119.97H161.625V106.936Z",
    fill: "url(#paint58_linear_47_2496)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M185.199 122.637H166.879C164.836 122.637 162.876 121.826 161.429 120.383C159.983 118.939 159.168 116.981 159.164 114.937V105.031H192.899V114.937C192.895 116.978 192.082 118.934 190.639 120.377C189.196 121.82 187.24 122.633 185.199 122.637ZM163.085 108.937V114.937C163.089 115.941 163.491 116.902 164.202 117.61C164.913 118.318 165.876 118.716 166.879 118.716H185.199C186.2 118.711 187.159 118.312 187.866 117.604C188.574 116.897 188.974 115.938 188.978 114.937V108.937H163.085Z",
    fill: "url(#paint59_linear_47_2496)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M185.199 122.637H166.879C164.836 122.637 162.876 121.826 161.429 120.383C159.983 118.939 159.168 116.981 159.164 114.937V105.031H192.899V114.937C192.895 116.978 192.082 118.934 190.639 120.377C189.196 121.82 187.24 122.633 185.199 122.637ZM163.085 108.937V114.937C163.089 115.941 163.491 116.902 164.202 117.61C164.913 118.318 165.876 118.716 166.879 118.716H185.199C186.2 118.711 187.159 118.312 187.866 117.604C188.574 116.897 188.974 115.938 188.978 114.937V108.937H163.085Z",
    fill: "url(#paint60_linear_47_2496)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M185.199 122.637H166.879C164.836 122.637 162.876 121.826 161.429 120.383C159.983 118.939 159.168 116.981 159.164 114.937V105.031H192.899V114.937C192.895 116.978 192.082 118.934 190.639 120.377C189.196 121.82 187.24 122.633 185.199 122.637ZM163.085 108.937V114.937C163.089 115.941 163.491 116.902 164.202 117.61C164.913 118.318 165.876 118.716 166.879 118.716H185.199C186.2 118.711 187.159 118.312 187.866 117.604C188.574 116.897 188.974 115.938 188.978 114.937V108.937H163.085Z",
    fill: "url(#paint61_linear_47_2496)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M175.739 108.937H188.979V114.937C188.975 115.938 188.576 116.897 187.868 117.604C187.16 118.312 186.202 118.711 185.201 118.716H175.676V122.637H185.201C187.242 122.633 189.198 121.82 190.641 120.377C192.084 118.934 192.896 116.978 192.9 114.937V105.031H175.739V108.937Z",
    fill: "url(#paint62_linear_47_2496)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M195.344 104.253C195.387 106.349 194.975 108.428 194.137 110.349C193.375 111.937 192.344 112.873 191.201 112.873H160.863C158.577 112.873 156.72 109.016 156.72 104.253C156.701 102.403 157.012 100.564 157.64 98.8239C158.02 97.5602 158.866 96.4878 160.006 95.8235L161.101 95.3473C161.273 95.2687 161.46 95.228 161.649 95.228C161.838 95.228 162.025 95.2687 162.197 95.3473C166.54 97.3284 171.258 98.3536 176.032 98.3536C180.806 98.3536 185.524 97.3284 189.867 95.3473C190.042 95.2684 190.231 95.2275 190.423 95.2275C190.614 95.2275 190.804 95.2684 190.978 95.3473L192.058 95.8235C193.979 96.649 195.344 100.173 195.344 104.253Z",
    fill: "url(#paint63_linear_47_2496)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M186.914 105.158C186.941 106.343 186.708 107.518 186.232 108.603C185.819 109.476 185.231 110.016 184.644 110.016H167.483C166.197 110.016 165.149 107.841 165.149 105.158C165.135 104.113 165.312 103.075 165.673 102.094C165.877 101.379 166.357 100.774 167.007 100.412L167.61 100.142C167.706 100.094 167.812 100.069 167.92 100.069C168.027 100.069 168.133 100.094 168.229 100.142C170.679 101.256 173.34 101.833 176.032 101.833C178.724 101.833 181.384 101.256 183.834 100.142C183.931 100.094 184.037 100.069 184.144 100.069C184.251 100.069 184.357 100.094 184.454 100.142L185.057 100.412C186.152 100.872 186.914 102.856 186.914 105.174V105.158Z",
    fill: "url(#paint64_linear_47_2496)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M156.721 104.253C156.721 109.016 158.578 112.873 160.864 112.873H191.202C192.345 112.873 193.377 111.905 194.139 110.349C194.976 108.428 195.388 106.348 195.345 104.253C195.345 103.713 195.345 103.189 195.345 102.666H156.8C156.8 103.174 156.721 103.697 156.721 104.253Z",
    fill: "url(#paint65_linear_47_2496)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M192.058 95.8235L190.979 95.3473C190.804 95.2684 190.615 95.2275 190.423 95.2275C190.232 95.2275 190.042 95.2684 189.868 95.3473C185.036 97.5216 179.762 98.5329 174.469 98.3V112.873H191.201C192.344 112.873 193.376 111.905 194.138 110.349C194.976 108.428 195.387 106.349 195.345 104.253C195.345 100.173 193.979 96.649 192.058 95.8235Z",
    fill: "url(#paint66_linear_47_2496)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M208.41 136.702H165.547C165.314 136.725 165.078 136.699 164.855 136.625C164.632 136.551 164.427 136.432 164.253 136.274C164.079 136.116 163.94 135.924 163.845 135.709C163.75 135.494 163.701 135.262 163.701 135.027C163.701 134.793 163.75 134.561 163.845 134.346C163.94 134.131 164.079 133.939 164.253 133.781C164.427 133.623 164.632 133.504 164.855 133.43C165.078 133.356 165.314 133.33 165.547 133.353H208.41C208.644 133.33 208.88 133.356 209.103 133.43C209.325 133.504 209.53 133.623 209.704 133.781C209.878 133.939 210.017 134.131 210.112 134.346C210.207 134.561 210.256 134.793 210.256 135.027C210.256 135.262 210.207 135.494 210.112 135.709C210.017 135.924 209.878 136.116 209.704 136.274C209.53 136.432 209.325 136.551 209.103 136.625C208.88 136.699 208.644 136.725 208.41 136.702Z",
    fill: "url(#paint67_linear_47_2496)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M152.419 141.084H143.655C143.21 141.08 142.785 140.901 142.47 140.586C142.155 140.272 141.977 139.846 141.973 139.401V130.638C141.997 130.208 142.185 129.804 142.498 129.509C142.811 129.214 143.225 129.05 143.655 129.05H152.419C152.634 129.04 152.849 129.073 153.05 129.148C153.252 129.223 153.437 129.338 153.593 129.486C153.749 129.635 153.873 129.813 153.957 130.011C154.042 130.209 154.086 130.423 154.085 130.638V139.401C154.085 139.845 153.91 140.27 153.598 140.585C153.286 140.9 152.862 141.08 152.419 141.084Z",
    fill: "url(#paint68_linear_47_2496)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M152.419 141.084H143.655C143.21 141.08 142.785 140.901 142.47 140.586C142.155 140.272 141.977 139.846 141.973 139.401V130.638C141.997 130.208 142.185 129.804 142.498 129.509C142.811 129.214 143.225 129.05 143.655 129.05H152.419C152.634 129.04 152.849 129.073 153.05 129.148C153.252 129.223 153.437 129.338 153.593 129.486C153.749 129.635 153.873 129.813 153.957 130.011C154.042 130.209 154.086 130.423 154.085 130.638V139.401C154.085 139.845 153.91 140.27 153.598 140.585C153.286 140.9 152.862 141.08 152.419 141.084Z",
    fill: "url(#paint69_linear_47_2496)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M152.419 141.084H143.655C143.21 141.08 142.785 140.901 142.47 140.586C142.155 140.272 141.977 139.846 141.973 139.401V130.638C141.997 130.208 142.185 129.804 142.498 129.509C142.811 129.214 143.225 129.05 143.655 129.05H152.419C152.634 129.04 152.849 129.073 153.05 129.148C153.252 129.223 153.437 129.338 153.593 129.486C153.749 129.635 153.873 129.813 153.957 130.011C154.042 130.209 154.086 130.423 154.085 130.638V139.401C154.085 139.845 153.91 140.27 153.598 140.585C153.286 140.9 152.862 141.08 152.419 141.084Z",
    fill: "url(#paint70_linear_47_2496)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M149.307 139.194C148.923 139.196 148.543 139.121 148.189 138.973C147.834 138.826 147.513 138.61 147.243 138.337L144.068 135.162C143.7 134.796 143.492 134.298 143.49 133.779C143.489 133.259 143.694 132.76 144.06 132.392C144.426 132.024 144.924 131.816 145.443 131.814C145.963 131.813 146.462 132.018 146.83 132.384L149.354 134.908L157.451 126.812C157.826 126.482 158.314 126.307 158.814 126.323C159.314 126.339 159.789 126.545 160.142 126.898C160.496 127.252 160.702 127.727 160.718 128.227C160.734 128.727 160.559 129.214 160.229 129.59L151.418 138.385C151.148 138.658 150.827 138.874 150.473 139.021C150.118 139.168 149.738 139.243 149.354 139.242L149.307 139.194Z",
    fill: "url(#paint71_linear_47_2496)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M149.307 139.194C148.923 139.196 148.543 139.121 148.189 138.973C147.834 138.826 147.513 138.61 147.243 138.337L144.068 135.162C143.7 134.796 143.492 134.298 143.49 133.779C143.489 133.259 143.694 132.76 144.06 132.392C144.426 132.024 144.924 131.816 145.443 131.814C145.963 131.813 146.462 132.018 146.83 132.384L149.354 134.908L157.451 126.812C157.826 126.482 158.314 126.307 158.814 126.323C159.314 126.339 159.789 126.545 160.142 126.898C160.496 127.252 160.702 127.727 160.718 128.227C160.734 128.727 160.559 129.214 160.229 129.59L151.418 138.385C151.148 138.658 150.827 138.874 150.473 139.021C150.118 139.168 149.738 139.243 149.354 139.242L149.307 139.194Z",
    fill: "url(#paint72_linear_47_2496)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M208.41 153.689H165.547C165.314 153.711 165.078 153.685 164.855 153.611C164.632 153.537 164.427 153.418 164.253 153.26C164.079 153.102 163.94 152.91 163.845 152.695C163.75 152.481 163.701 152.249 163.701 152.014C163.701 151.779 163.75 151.547 163.845 151.332C163.94 151.118 164.079 150.925 164.253 150.768C164.427 150.61 164.632 150.49 164.855 150.416C165.078 150.343 165.314 150.316 165.547 150.339H208.41C208.644 150.316 208.88 150.343 209.103 150.416C209.325 150.49 209.53 150.61 209.704 150.768C209.878 150.925 210.017 151.118 210.112 151.332C210.207 151.547 210.256 151.779 210.256 152.014C210.256 152.249 210.207 152.481 210.112 152.695C210.017 152.91 209.878 153.102 209.704 153.26C209.53 153.418 209.325 153.537 209.103 153.611C208.88 153.685 208.644 153.711 208.41 153.689Z",
    fill: "url(#paint73_linear_47_2496)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M152.419 158.038H143.655C143.21 158.034 142.785 157.856 142.47 157.541C142.155 157.226 141.977 156.801 141.973 156.356V147.592C141.997 147.163 142.185 146.759 142.498 146.464C142.811 146.168 143.225 146.004 143.655 146.005H152.419C152.634 145.994 152.849 146.027 153.05 146.102C153.252 146.177 153.437 146.292 153.593 146.441C153.749 146.589 153.873 146.768 153.957 146.966C154.042 147.164 154.086 147.377 154.085 147.592V156.356C154.085 156.799 153.91 157.225 153.598 157.54C153.286 157.855 152.862 158.034 152.419 158.038Z",
    fill: "url(#paint74_linear_47_2496)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M152.419 158.038H143.655C143.21 158.034 142.785 157.856 142.47 157.541C142.155 157.226 141.977 156.801 141.973 156.356V147.592C141.997 147.163 142.185 146.759 142.498 146.464C142.811 146.168 143.225 146.004 143.655 146.005H152.419C152.634 145.994 152.849 146.027 153.05 146.102C153.252 146.177 153.437 146.292 153.593 146.441C153.749 146.589 153.873 146.768 153.957 146.966C154.042 147.164 154.086 147.377 154.085 147.592V156.356C154.085 156.799 153.91 157.225 153.598 157.54C153.286 157.855 152.862 158.034 152.419 158.038Z",
    fill: "url(#paint75_linear_47_2496)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M152.419 158.038H143.655C143.21 158.034 142.785 157.856 142.47 157.541C142.155 157.226 141.977 156.801 141.973 156.356V147.592C141.997 147.163 142.185 146.759 142.498 146.464C142.811 146.168 143.225 146.004 143.655 146.005H152.419C152.634 145.994 152.849 146.027 153.05 146.102C153.252 146.177 153.437 146.292 153.593 146.441C153.749 146.589 153.873 146.768 153.957 146.966C154.042 147.164 154.086 147.377 154.085 147.592V156.356C154.085 156.799 153.91 157.225 153.598 157.54C153.286 157.855 152.862 158.034 152.419 158.038Z",
    fill: "url(#paint76_linear_47_2496)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M149.307 156.15C148.923 156.151 148.543 156.076 148.189 155.929C147.834 155.781 147.513 155.565 147.243 155.292L144.068 152.117C143.7 151.751 143.492 151.253 143.49 150.734C143.489 150.214 143.694 149.715 144.06 149.347C144.426 148.979 144.924 148.771 145.443 148.769C145.963 148.768 146.462 148.973 146.83 149.339L149.354 151.863L157.451 143.767C157.826 143.437 158.314 143.262 158.814 143.278C159.314 143.294 159.789 143.5 160.142 143.853C160.496 144.207 160.702 144.682 160.718 145.182C160.734 145.682 160.559 146.169 160.229 146.545L151.371 155.276C151.101 155.549 150.779 155.765 150.425 155.913C150.071 156.06 149.69 156.135 149.307 156.134V156.15Z",
    fill: "url(#paint77_linear_47_2496)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M149.307 156.15C148.923 156.151 148.543 156.076 148.189 155.929C147.834 155.781 147.513 155.565 147.243 155.292L144.068 152.117C143.7 151.751 143.492 151.253 143.49 150.734C143.489 150.214 143.694 149.715 144.06 149.347C144.426 148.979 144.924 148.771 145.443 148.769C145.963 148.768 146.462 148.973 146.83 149.339L149.354 151.863L157.451 143.767C157.826 143.437 158.314 143.262 158.814 143.278C159.314 143.294 159.789 143.5 160.142 143.853C160.496 144.207 160.702 144.682 160.718 145.182C160.734 145.682 160.559 146.169 160.229 146.545L151.371 155.276C151.101 155.549 150.779 155.765 150.425 155.913C150.071 156.06 149.69 156.135 149.307 156.134V156.15Z",
    fill: "url(#paint78_linear_47_2496)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M208.41 170.612H165.547C165.314 170.634 165.078 170.608 164.855 170.534C164.632 170.46 164.427 170.341 164.253 170.183C164.079 170.025 163.94 169.833 163.845 169.618C163.75 169.404 163.701 169.171 163.701 168.937C163.701 168.702 163.75 168.47 163.845 168.255C163.94 168.04 164.079 167.848 164.253 167.69C164.427 167.533 164.632 167.413 164.855 167.339C165.078 167.265 165.314 167.239 165.547 167.262H208.41C208.644 167.239 208.88 167.265 209.103 167.339C209.325 167.413 209.53 167.533 209.704 167.69C209.878 167.848 210.017 168.04 210.112 168.255C210.207 168.47 210.256 168.702 210.256 168.937C210.256 169.171 210.207 169.404 210.112 169.618C210.017 169.833 209.878 170.025 209.704 170.183C209.53 170.341 209.325 170.46 209.103 170.534C208.88 170.608 208.644 170.634 208.41 170.612Z",
    fill: "url(#paint79_linear_47_2496)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M152.419 174.993H143.655C143.21 174.989 142.785 174.811 142.47 174.496C142.155 174.181 141.977 173.756 141.973 173.311V164.547C141.977 164.104 142.156 163.68 142.471 163.368C142.786 163.056 143.212 162.88 143.655 162.881H152.419C152.64 162.869 152.862 162.904 153.07 162.984C153.277 163.064 153.465 163.186 153.623 163.343C153.78 163.501 153.902 163.689 153.982 163.896C154.062 164.104 154.097 164.326 154.085 164.547V173.311C154.085 173.754 153.91 174.18 153.598 174.495C153.286 174.81 152.862 174.989 152.419 174.993Z",
    fill: "url(#paint80_linear_47_2496)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M152.419 174.993H143.655C143.21 174.989 142.785 174.811 142.47 174.496C142.155 174.181 141.977 173.756 141.973 173.311V164.547C141.977 164.104 142.156 163.68 142.471 163.368C142.786 163.056 143.212 162.88 143.655 162.881H152.419C152.64 162.869 152.862 162.904 153.07 162.984C153.277 163.064 153.465 163.186 153.623 163.343C153.78 163.501 153.902 163.689 153.982 163.896C154.062 164.104 154.097 164.326 154.085 164.547V173.311C154.085 173.754 153.91 174.18 153.598 174.495C153.286 174.81 152.862 174.989 152.419 174.993Z",
    fill: "url(#paint81_linear_47_2496)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M152.419 174.993H143.655C143.21 174.989 142.785 174.811 142.47 174.496C142.155 174.181 141.977 173.756 141.973 173.311V164.547C141.977 164.104 142.156 163.68 142.471 163.368C142.786 163.056 143.212 162.88 143.655 162.881H152.419C152.64 162.869 152.862 162.904 153.07 162.984C153.277 163.064 153.465 163.186 153.623 163.343C153.78 163.501 153.902 163.689 153.982 163.896C154.062 164.104 154.097 164.326 154.085 164.547V173.311C154.085 173.754 153.91 174.18 153.598 174.495C153.286 174.81 152.862 174.989 152.419 174.993Z",
    fill: "url(#paint82_linear_47_2496)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M149.307 173.104C148.923 173.105 148.543 173.03 148.189 172.883C147.834 172.736 147.513 172.52 147.243 172.247L144.068 169.072C143.7 168.705 143.492 168.208 143.49 167.688C143.489 167.169 143.694 166.67 144.06 166.302C144.426 165.933 144.924 165.725 145.443 165.724C145.963 165.722 146.462 165.927 146.83 166.294L149.354 168.818L157.451 160.721C157.826 160.391 158.314 160.216 158.814 160.232C159.314 160.249 159.789 160.454 160.142 160.808C160.496 161.162 160.702 161.637 160.718 162.137C160.734 162.637 160.559 163.124 160.229 163.5L151.418 172.294C151.148 172.567 150.827 172.784 150.473 172.931C150.118 173.078 149.738 173.153 149.354 173.152L149.307 173.104Z",
    fill: "url(#paint83_linear_47_2496)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M149.307 173.104C148.923 173.105 148.543 173.03 148.189 172.883C147.834 172.736 147.513 172.52 147.243 172.247L144.068 169.072C143.7 168.705 143.492 168.208 143.49 167.688C143.489 167.169 143.694 166.67 144.06 166.302C144.426 165.933 144.924 165.725 145.443 165.724C145.963 165.722 146.462 165.927 146.83 166.294L149.354 168.818L157.451 160.721C157.826 160.391 158.314 160.216 158.814 160.232C159.314 160.249 159.789 160.454 160.142 160.808C160.496 161.162 160.702 161.637 160.718 162.137C160.734 162.637 160.559 163.124 160.229 163.5L151.418 172.294C151.148 172.567 150.827 172.784 150.473 172.931C150.118 173.078 149.738 173.153 149.354 173.152L149.307 173.104Z",
    fill: "url(#paint84_linear_47_2496)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M208.41 187.582H165.547C165.314 187.605 165.078 187.579 164.855 187.505C164.632 187.431 164.427 187.311 164.253 187.154C164.079 186.996 163.94 186.804 163.845 186.589C163.75 186.374 163.701 186.142 163.701 185.907C163.701 185.673 163.75 185.44 163.845 185.226C163.94 185.011 164.079 184.819 164.253 184.661C164.427 184.503 164.632 184.384 164.855 184.31C165.078 184.236 165.314 184.21 165.547 184.233H208.41C208.644 184.21 208.88 184.236 209.103 184.31C209.325 184.384 209.53 184.503 209.704 184.661C209.878 184.819 210.017 185.011 210.112 185.226C210.207 185.44 210.256 185.673 210.256 185.907C210.256 186.142 210.207 186.374 210.112 186.589C210.017 186.804 209.878 186.996 209.704 187.154C209.53 187.311 209.325 187.431 209.103 187.505C208.88 187.579 208.644 187.605 208.41 187.582Z",
    fill: "url(#paint85_linear_47_2496)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M152.419 191.964H143.655C143.21 191.96 142.785 191.781 142.47 191.467C142.155 191.152 141.977 190.726 141.973 190.281V181.518C141.977 181.075 142.156 180.651 142.471 180.338C142.786 180.026 143.212 179.851 143.655 179.851H152.419C152.64 179.84 152.862 179.875 153.07 179.955C153.277 180.035 153.465 180.157 153.623 180.314C153.78 180.471 153.902 180.66 153.982 180.867C154.062 181.074 154.097 181.296 154.085 181.518V190.281C154.085 190.725 153.91 191.15 153.598 191.466C153.286 191.781 152.862 191.96 152.419 191.964Z",
    fill: "url(#paint86_linear_47_2496)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M152.419 191.964H143.655C143.21 191.96 142.785 191.781 142.47 191.467C142.155 191.152 141.977 190.726 141.973 190.281V181.518C141.977 181.075 142.156 180.651 142.471 180.338C142.786 180.026 143.212 179.851 143.655 179.851H152.419C152.64 179.84 152.862 179.875 153.07 179.955C153.277 180.035 153.465 180.157 153.623 180.314C153.78 180.471 153.902 180.66 153.982 180.867C154.062 181.074 154.097 181.296 154.085 181.518V190.281C154.085 190.725 153.91 191.15 153.598 191.466C153.286 191.781 152.862 191.96 152.419 191.964Z",
    fill: "url(#paint87_linear_47_2496)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M152.419 191.964H143.655C143.21 191.96 142.785 191.781 142.47 191.467C142.155 191.152 141.977 190.726 141.973 190.281V181.518C141.977 181.075 142.156 180.651 142.471 180.338C142.786 180.026 143.212 179.851 143.655 179.851H152.419C152.64 179.84 152.862 179.875 153.07 179.955C153.277 180.035 153.465 180.157 153.623 180.314C153.78 180.471 153.902 180.66 153.982 180.867C154.062 181.074 154.097 181.296 154.085 181.518V190.281C154.085 190.725 153.91 191.15 153.598 191.466C153.286 191.781 152.862 191.96 152.419 191.964Z",
    fill: "url(#paint88_linear_47_2496)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M208.41 204.489H165.547C165.314 204.512 165.078 204.486 164.855 204.412C164.632 204.338 164.427 204.219 164.253 204.061C164.079 203.903 163.94 203.711 163.845 203.496C163.75 203.282 163.701 203.049 163.701 202.815C163.701 202.58 163.75 202.348 163.845 202.133C163.94 201.918 164.079 201.726 164.253 201.568C164.427 201.411 164.632 201.291 164.855 201.217C165.078 201.143 165.314 201.117 165.547 201.14H208.41C208.644 201.117 208.88 201.143 209.103 201.217C209.325 201.291 209.53 201.411 209.704 201.568C209.878 201.726 210.017 201.918 210.112 202.133C210.207 202.348 210.256 202.58 210.256 202.815C210.256 203.049 210.207 203.282 210.112 203.496C210.017 203.711 209.878 203.903 209.704 204.061C209.53 204.219 209.325 204.338 209.103 204.412C208.88 204.486 208.644 204.512 208.41 204.489Z",
    fill: "url(#paint89_linear_47_2496)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M152.419 208.935H143.655C143.209 208.935 142.781 208.757 142.466 208.442C142.15 208.126 141.973 207.698 141.973 207.252V198.505C141.973 198.284 142.016 198.065 142.101 197.861C142.185 197.656 142.309 197.471 142.466 197.315C142.622 197.158 142.807 197.034 143.011 196.95C143.216 196.865 143.434 196.822 143.655 196.822H152.419C152.639 196.822 152.857 196.865 153.06 196.95C153.263 197.035 153.448 197.159 153.603 197.316C153.758 197.472 153.88 197.658 153.963 197.862C154.046 198.066 154.087 198.284 154.085 198.505V207.252C154.087 207.472 154.046 207.69 153.963 207.895C153.88 208.099 153.758 208.284 153.603 208.441C153.448 208.597 153.263 208.721 153.06 208.806C152.857 208.891 152.639 208.935 152.419 208.935Z",
    fill: "url(#paint90_linear_47_2496)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M152.419 208.935H143.655C143.209 208.935 142.781 208.757 142.466 208.442C142.15 208.126 141.973 207.698 141.973 207.252V198.505C141.973 198.284 142.016 198.065 142.101 197.861C142.185 197.656 142.309 197.471 142.466 197.315C142.622 197.158 142.807 197.034 143.011 196.95C143.216 196.865 143.434 196.822 143.655 196.822H152.419C152.639 196.822 152.857 196.865 153.06 196.95C153.263 197.035 153.448 197.159 153.603 197.316C153.758 197.472 153.88 197.658 153.963 197.862C154.046 198.066 154.087 198.284 154.085 198.505V207.252C154.087 207.472 154.046 207.69 153.963 207.895C153.88 208.099 153.758 208.284 153.603 208.441C153.448 208.597 153.263 208.721 153.06 208.806C152.857 208.891 152.639 208.935 152.419 208.935Z",
    fill: "url(#paint91_linear_47_2496)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M152.419 208.935H143.655C143.209 208.935 142.781 208.757 142.466 208.442C142.15 208.126 141.973 207.698 141.973 207.252V198.505C141.973 198.284 142.016 198.065 142.101 197.861C142.185 197.656 142.309 197.471 142.466 197.315C142.622 197.158 142.807 197.034 143.011 196.95C143.216 196.865 143.434 196.822 143.655 196.822H152.419C152.639 196.822 152.857 196.865 153.06 196.95C153.263 197.035 153.448 197.159 153.603 197.316C153.758 197.472 153.88 197.658 153.963 197.862C154.046 198.066 154.087 198.284 154.085 198.505V207.252C154.087 207.472 154.046 207.69 153.963 207.895C153.88 208.099 153.758 208.284 153.603 208.441C153.448 208.597 153.263 208.721 153.06 208.806C152.857 208.891 152.639 208.935 152.419 208.935Z",
    fill: "url(#paint92_linear_47_2496)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_2496",
    x1: 46.5939,
    y1: 70.4391,
    x2: 155.498,
    y2: 168.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72B3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0969B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47_2496",
    x1: 91.7107,
    y1: 70.7246,
    x2: 91.7107,
    y2: 64.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72B3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0969B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_47_2496",
    x1: 91.7107,
    y1: 62.3745,
    x2: 91.7107,
    y2: 56.2308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72B3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0969B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_47_2496",
    x1: 91.7107,
    y1: 54.04,
    x2: 91.7107,
    y2: 47.8805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72B3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0969B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_47_2496",
    x1: 91.7107,
    y1: 45.6895,
    x2: 91.7107,
    y2: 39.5458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72B3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0969B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_47_2496",
    x1: 77.8199,
    y1: 48.2774,
    x2: 68.6281,
    y2: 29.1636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#044C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#034764",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#10375B",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#181E4B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181E4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_47_2496",
    x1: 105.586,
    y1: 48.2615,
    x2: 114.777,
    y2: 29.1636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#044C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#034764",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#10375B",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#181E4B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181E4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_47_2496",
    x1: 157.117,
    y1: 90.9658,
    x2: 180.549,
    y2: 90.9658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#044C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#034764",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#10375B",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#181E4B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181E4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_47_2496",
    x1: 91.7112,
    y1: 159.245,
    x2: 91.7112,
    y2: 184.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#044C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#034764",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#10375B",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#181E4B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181E4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_47_2496",
    x1: 91.7106,
    y1: 3.92182,
    x2: 91.7106,
    y2: 64.9302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_47_2496",
    x1: 89.885,
    y1: 4.1282,
    x2: 91.8535,
    y2: 59.2469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_47_2496",
    x1: 91.7116,
    y1: 43.3721,
    x2: 91.7116,
    y2: -1.1579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_47_2496",
    x1: 174.103,
    y1: 44.372,
    x2: 184.342,
    y2: 44.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_47_2496",
    x1: 152.482,
    y1: 45.8168,
    x2: 152.482,
    y2: 66.6609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_47_2496",
    x1: 30.9402,
    y1: 45.8167,
    x2: 30.9402,
    y2: 66.6609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_47_2496",
    x1: 74.265,
    y1: 100.316,
    x2: 105.412,
    y2: 162.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_47_2496",
    x1: 140.051,
    y1: 151.672,
    x2: 113.159,
    y2: 149.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#403C40",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#363336",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#252425",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_47_2496",
    x1: 67.7403,
    y1: 132.686,
    x2: 40.1491,
    y2: 132.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#403C40",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#363336",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#252425",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_47_2496",
    x1: 91.7118,
    y1: 110.73,
    x2: 91.7118,
    y2: 87.2347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#403C40",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#363336",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#252425",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_47_2496",
    x1: 29.4795,
    y1: 128.923,
    x2: 108.236,
    y2: 192.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_47_2496",
    x1: 100.093,
    y1: 163.865,
    x2: 115.397,
    y2: 163.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_47_2496",
    x1: 42.9893,
    y1: 155.594,
    x2: 75.2635,
    y2: 195.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_47_2496",
    x1: 85.7745,
    y1: 142.798,
    x2: 90.7593,
    y2: 163.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_47_2496",
    x1: 45.4182,
    y1: 183.55,
    x2: 43.4973,
    y2: 193.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_47_2496",
    x1: 92.5517,
    y1: 183.55,
    x2: 94.4726,
    y2: 193.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_47_2496",
    x1: 68.6765,
    y1: 129.78,
    x2: 69.8831,
    y2: 145.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_47_2496",
    x1: 55.2611,
    y1: 130.606,
    x2: 56.1342,
    y2: 134.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_47_2496",
    x1: 61.0713,
    y1: 126.955,
    x2: 67.2785,
    y2: 142.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C610"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_47_2496",
    x1: 50.7845,
    y1: 136.178,
    x2: 50.7845,
    y2: 139.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_47_2496",
    x1: 45.9739,
    y1: 145.862,
    x2: 48.387,
    y2: 145.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_47_2496",
    x1: 43.7358,
    y1: 151.022,
    x2: 43.2436,
    y2: 153.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_47_2496",
    x1: 32.2423,
    y1: 168.865,
    x2: 43.3391,
    y2: 187.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_47_2496",
    x1: 37.8463,
    y1: 180.645,
    x2: 37.0049,
    y2: 184.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_47_2496",
    x1: 45.0539,
    y1: 179.756,
    x2: 47.9432,
    y2: 179.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_47_2496",
    x1: 60.4211,
    y1: 160.721,
    x2: 139.162,
    y2: 223.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_47_2496",
    x1: 131.019,
    y1: 195.663,
    x2: 146.339,
    y2: 195.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_47_2496",
    x1: 73.9309,
    y1: 187.392,
    x2: 106.205,
    y2: 227.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_47_2496",
    x1: 76.344,
    y1: 215.348,
    x2: 74.4389,
    y2: 225.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_47_2496",
    x1: 123.493,
    y1: 215.348,
    x2: 125.398,
    y2: 225.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_47_2496",
    x1: 99.6163,
    y1: 161.579,
    x2: 100.807,
    y2: 177.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_47_2496",
    x1: 86.1856,
    y1: 162.404,
    x2: 87.0746,
    y2: 166.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF5539",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF4E35",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#944331",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_47_2496",
    x1: 91.9959,
    y1: 158.753,
    x2: 98.2189,
    y2: 173.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C610"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_47_2496",
    x1: 81.7259,
    y1: 167.976,
    x2: 81.7259,
    y2: 171.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_47_2496",
    x1: 76.8995,
    y1: 177.66,
    x2: 79.3125,
    y2: 177.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_47_2496",
    x1: 74.6611,
    y1: 182.82,
    x2: 74.1848,
    y2: 185.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_47_2496",
    x1: 63.184,
    y1: 200.663,
    x2: 74.2808,
    y2: 219.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_47_2496",
    x1: 68.7877,
    y1: 212.459,
    x2: 67.9304,
    y2: 216.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_47_2496",
    x1: 75.9787,
    y1: 211.554,
    x2: 78.868,
    y2: 211.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_47_2496",
    x1: 105.141,
    y1: 112.905,
    x2: 258.671,
    y2: 226.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC6EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_47_2496",
    x1: 219.507,
    y1: 165.214,
    x2: 229.619,
    y2: 165.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34A5DE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A5DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_47_2496",
    x1: 204.06,
    y1: 117.874,
    x2: 190.646,
    y2: 115.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34A5DE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A5DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_47_2496",
    x1: 215.459,
    y1: 171.12,
    x2: 187.884,
    y2: 152.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34A5DE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A5DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_47_2496",
    x1: 176.04,
    y1: 219.92,
    x2: 176.04,
    y2: 229.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34A5DE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A5DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_47_2496",
    x1: 148.607,
    y1: 137.385,
    x2: 224.538,
    y2: 213.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_47_2496",
    x1: 199.854,
    y1: 131.019,
    x2: 186.645,
    y2: 107.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_47_2496",
    x1: 212.045,
    y1: 164.817,
    x2: 220.458,
    y2: 164.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_47_2496",
    x1: 176.04,
    y1: 211.681,
    x2: 176.04,
    y2: 222.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_47_2496",
    x1: 176.04,
    y1: 118.477,
    x2: 176.04,
    y2: 112.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_47_2496",
    x1: 169.769,
    y1: 113.445,
    x2: 163.07,
    y2: 113.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_47_2496",
    x1: 176.039,
    y1: 119.16,
    x2: 176.039,
    y2: 122.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_47_2496",
    x1: 176.039,
    y1: 119.525,
    x2: 176.039,
    y2: 122.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#403C40",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#363336",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#252425",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_47_2496",
    x1: 176.039,
    y1: 116.493,
    x2: 176.039,
    y2: 112.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#403C40",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#363336",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#252425",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_47_2496",
    x1: 187.614,
    y1: 115.16,
    x2: 192.075,
    y2: 116.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#403C40",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#363336",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#252425",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_47_2496",
    x1: 176.04,
    y1: 99.57,
    x2: 176.04,
    y2: 112.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C610"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_47_2496",
    x1: 176.04,
    y1: 110.635,
    x2: 176.04,
    y2: 97.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C610"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_47_2496",
    x1: 176.041,
    y1: 109.016,
    x2: 176.041,
    y2: 113.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_47_2496",
    x1: 187.217,
    y1: 104.602,
    x2: 195.662,
    y2: 105.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8963A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8963A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_47_2496",
    x1: 186.677,
    y1: 91.4897,
    x2: 187.058,
    y2: 146.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_47_2496",
    x1: 136.861,
    y1: 123.843,
    x2: 156.276,
    y2: 143.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_47_2496",
    x1: 148.037,
    y1: 135.115,
    x2: 148.037,
    y2: 128.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_47_2496",
    x1: 151.847,
    y1: 135.019,
    x2: 140.48,
    y2: 135.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_47_2496",
    x1: 151.672,
    y1: 128.764,
    x2: 153.387,
    y2: 137.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B6D668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#A5CF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#89BC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77AA41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_47_2496",
    x1: 153.784,
    y1: 132.638,
    x2: 155.45,
    y2: 134.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374D22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#384D22",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#394A20",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#3C482C",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#444444",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_47_2496",
    x1: 186.677,
    y1: 108.444,
    x2: 187.058,
    y2: 163.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_47_2496",
    x1: 136.861,
    y1: 140.798,
    x2: 156.276,
    y2: 160.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_47_2496",
    x1: 148.037,
    y1: 152.069,
    x2: 148.037,
    y2: 145.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_47_2496",
    x1: 151.847,
    y1: 151.974,
    x2: 140.48,
    y2: 151.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_47_2496",
    x1: 151.672,
    y1: 145.72,
    x2: 153.387,
    y2: 154.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B6D668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#A5CF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#89BC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77AA41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_47_2496",
    x1: 153.784,
    y1: 149.593,
    x2: 155.45,
    y2: 151.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374D22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#384D22",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#394A20",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#3C482C",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#444444",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_47_2496",
    x1: 186.677,
    y1: 125.399,
    x2: 187.058,
    y2: 180.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_47_2496",
    x1: 136.861,
    y1: 157.753,
    x2: 156.276,
    y2: 177.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_47_2496",
    x1: 148.037,
    y1: 169.024,
    x2: 148.037,
    y2: 162.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_47_2496",
    x1: 151.847,
    y1: 168.929,
    x2: 140.48,
    y2: 168.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_47_2496",
    x1: 151.672,
    y1: 162.674,
    x2: 153.387,
    y2: 171.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B6D668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#A5CF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#89BC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77AA41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_47_2496",
    x1: 153.784,
    y1: 166.548,
    x2: 155.45,
    y2: 168.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374D22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#384D22",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#394A20",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#3C482C",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#444444",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_47_2496",
    x1: 186.677,
    y1: 142.37,
    x2: 187.058,
    y2: 197.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_47_2496",
    x1: 136.861,
    y1: 174.724,
    x2: 156.276,
    y2: 194.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_47_2496",
    x1: 148.037,
    y1: 185.995,
    x2: 148.037,
    y2: 179.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_47_2496",
    x1: 151.847,
    y1: 185.9,
    x2: 140.48,
    y2: 185.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_47_2496",
    x1: 186.677,
    y1: 159.34,
    x2: 187.058,
    y2: 214.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_47_2496",
    x1: 136.861,
    y1: 191.694,
    x2: 156.276,
    y2: 211.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_47_2496",
    x1: 148.037,
    y1: 202.965,
    x2: 148.037,
    y2: 196.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_47_2496",
    x1: 151.847,
    y1: 202.87,
    x2: 140.48,
    y2: 202.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9D2E8",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D5C9E3",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#CBB9DB",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFA5CF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AE8ABF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274B2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW3);
export default __webpack_public_path__ + "static/media/w3.a86ac1efd1bfa15fdca60b73f1977f74.svg";
export { ForwardRef as ReactComponent };